import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Voting } from "./pages/Voting/Voting";
import { Results } from "./pages/Results/Results";
import { Login } from "./pages/Login/Login";
import { End } from "./pages/End/End";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Navigate to={"/voting/1"} />} />
        <Route path="/voting" element={<Navigate to={"/voting/1"} />} />
        <Route path="/voting/:id" element={<Voting />} />
        <Route path="/login" element={<Login />} />
        <Route path="/results/:eventId" element={<Results />} />
        <Route path="/end" element={<End />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
